import { render, staticRenderFns } from "./PageSegmentos.vue?vue&type=template&id=5b883b3f&scoped=true&"
import script from "./PageSegmentos.vue?vue&type=script&lang=js&"
export * from "./PageSegmentos.vue?vue&type=script&lang=js&"
import style0 from "./PageSegmentos.vue?vue&type=style&index=0&id=5b883b3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b883b3f",
  null
  
)

export default component.exports